import _sfc_main from "./index70.js";
/* empty css        */
import _export_sfc from "./index63.js";
const SalesButtonFace = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-6a92fa49"]]);
export {
  SalesButtonFace as default
};
//# sourceMappingURL=index12.js.map
